<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";
import ProfileMenu from "@/components/ui/ProfileMenu.vue";

defineProps(["title"]);
const authStore = useAuthStore();
</script>

<template>
  <h1 class="profileTitle" v-if="authStore.isAdmin">Administrador</h1>
  <h1 class="profileTitle" v-else>Perfil</h1>
  <div class="profile">
    <div class="row">
      <div class="col-12 col-md-3 col-lg-2">
        <ProfileMenu />
      </div>
      <div class="col-12 col-md-9 col-lg-10">
        <div class="profileContent">
          <h1 class="profileSubTitle">{{ title }}</h1>
          <div class="profileContentNav">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.profileTitle {
  margin-top: 20px;
  font-weight: 600;
  font-size: 18px;
  color: var(--primary-color);
}

.profileSubTitle {
  margin-top: 0px;
  font-weight: 400;
  font-size: 18px;
  color: var(--primary-color);
  padding-top: 2px;
}

.profile {
  background-color: var(--dark-color);
  color: var(--white-ice);
  border-radius: 0.5rem;
  padding: 15px;
}

.profile h5 {
  font-size: 14px;
  font-weight: 500;
  margin: 0 auto;
}

/* .profile ul {
  list-style: none;
  padding: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
}

  .profile ul li {
    border-right: 2px solid var(--dark-grey);
  }

.profile ul li:last-child {
  width: 100%;
  border: none;
} */

.profileContent h5 {
  margin-bottom: 5px;
}

.profileContentNav {
  border: 1px solid var(--dark-grey);
  border-radius: 0.25rem;
  padding: 10px 10px 0;
  display: block;
}

.profileContentNav:last-child {
  margin-bottom: 0 auto;
}

.profileContentNav .form-control {
  background-color: var(--dark-color);
  color: var(--white-ice);
  border-color: var(--dark-grey);
}

.profileContentNav .form-select {
  background-color: var(--dark-color);
  color: var(--white-ice);
  border-color: var(--dark-grey);
}

.footer {
  margin: 0 auto;
}

.form-control:disabled {
  color: var(--dark-grey);
}

@media (max-width: 767.98px) {
  /* .container{
    padding: 0 25px;
  } */

  .profile {
    padding: 5px;
  }

  .profileTitle {
    margin-top: 0;
    margin-left: 15px;
  }

  /* .profile .row {
    flex-direction: column;
  } */

  /* .profile ul {
    flex-direction: column;
  }

  .profile ul li {
    border: none;
    border-bottom: 1px solid var(--dark-grey);
  } */

  .profileContent {
    padding: 10px;
  }
}
</style>
